import { environment } from '../../../../environments/environment';
import { SQLService } from '../../../services/sql.service';
import { Component, OnInit, Input, EventEmitter,ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ModalController, NavParams } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import * as Languages from './languages/index';
@Component({
	selector: 'app-disclaimer',
	templateUrl: './disclaimer.component.html',
	styleUrls: ['./disclaimer.component.styl']
})
export class DisclaimerComponent implements OnInit {
	constructor(
		private router: Router,
		public sql: SQLService,
		private route: ActivatedRoute,
		private navCtrl: ModalController,
		private params: NavParams,
		private current_platform: Platform,
		private location: Location
	) {
    	this.force = params.get('force');
		this.router.events.subscribe((eve) => {
			//if(eve instanceof NavigationEnd) this.get_purchase();
		});
	}
	force=true;
	contents='';
	ngOnInit() { 
		this.contents=Languages[this.sql.Language.replace('-','').toLowerCase()].translation;
		console.log('sql.Language',this.sql.Language.replace('-','').toLowerCase(),this.contents);
	}
	end(agreement=false) {
		if(!agreement&&this.force)alert(this.sql.word.Terms_Required_Word);
		if(agreement||this.force==false)this.navCtrl.dismiss(agreement);
	}
}